import React, { useEffect, useState } from "react";
import moment from "moment";
import "./InterviewCoverageSummary.scss";

export function InterviewInternalCoverageCard(props) {
    let planStartDate = "12-09-2021";
    return (
        <div>
            <div className="health_benefit_plan_coverage_container">
                {props.coverage?.healthInsuranceType?.name}
            </div>
            <div className="active_coverage active_coverage_internal">Active Coverage</div>
            <div className="plan_or_product_name">Plan</div>
            <div className="plan_or_product_name_value">
                {props.coverage?.plan}
            </div>
            <div className="plan_start_date plan_start_date_internal">Plan Start Date</div>
            <div className="plan_start_date_value plan_start_date_value">{moment(props.coverage?.effectiveDate).format("MM.DD.YYYY")}</div>
        </div>
    );
}